import Script from "next/script";
import React from "react";

declare global {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  interface Window {
    Chargebee?: {
      init: (options: { site: string; enableGTMTracking?: boolean }) => void;
    };
  }
}

export const ChargebeeScript: React.FC = () => (
  <>
    <Script
      strategy="afterInteractive"
      src="https://js.chargebee.com/v2/chargebee.js"
      onLoad={() => {
        // Auto-init via data-cb-* attributes only runs for statically
        // embedded scripts; afterInteractive injects the tag dynamically,
        // so the instance must be created explicitly.
        window.Chargebee?.init({
          site: process.env.NEXT_PUBLIC_XD2SKETCH_CHARGEBEE_SITE as string,
          enableGTMTracking: true,
        });
      }}
    />
  </>
);
